import { Fragment } from 'react'

import { Card } from '@tribeplatform/react-ui-kit/Card'
import { List } from '@tribeplatform/react-ui-kit/Layout'

export const SearchLoading = ({ multisection = false }) => {
  return (
    <>
      {[...Array(!multisection ? 10 : 3)].map((_e, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={i}>
          {multisection && (
            <div className="px-2 pb-3 animate-pulse">
              <div className="h-4 bg-surface-100 rounded-full w-1/12" />
            </div>
          )}
          <Card className="mb-5">
            <List spacing="none" divider>
              {[...Array(3)].map((_e, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <List.Item key={i}>
                  <div className="px-6 py-5 animate-pulse flex flex-col space-y-4 mt-3">
                    <div className="h-4 bg-surface-300 rounded-full w-3/4" />
                    <div className="h-4 bg-surface-300 rounded-full w-11/12" />
                  </div>
                </List.Item>
              ))}
            </List>
          </Card>
        </Fragment>
      ))}
    </>
  )
}
